import { FormMultiSelect } from '@/modules/forms/components/FormMultiSelect';
import type { MultiSelectProps } from '@/modules/ui/MultiSelect';

interface UsersMultiSelectProps {
  options: MultiSelectProps['options'];
}

export const UsersMultiSelect = ({ options }: UsersMultiSelectProps) => {
  return (
    <FormMultiSelect
      name="userIds"
      label="Assigned to"
      options={options}
      placeholder="Select assignees"
    />
  );
};
